import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { ListWrapper } from './list/ListWrapper'

const paymentOptionBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/payment-options',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const PaymentOptionPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={paymentOptionBreadcrumbs}>Lista de Formas de Pagamento</PageTitle>
      <ListWrapper />
    </>
  )
}

export default PaymentOptionPage
